import { Container } from '@mui/material';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import Page from '../../../components/Page';
import { useParams } from 'react-router-dom';
import ToppingsCategoryForm from './ToppingsCategoryForm';

const index = () => {
  const params: any = useParams();
  const isAddMode = !params?.id;
  return (
    <Page title={'Toppings Category'}>
      <Container maxWidth={'xl'}>
        <HeaderBreadcrumbs
          heading={`${isAddMode ? 'Add Toppings Category' : 'Edit Toppings Category'} `}
          links={[
            { name: 'Dashboard', href: '/' },
            { name: 'Toppings Category', href: '/toppings-category' },
          ]}
        />
        <ToppingsCategoryForm />
      </Container>
    </Page>
  );
};

export default index;
